import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureAddressValidationMemberPortal(): boolean {
  return useFeatureEnabled('ADDRESS_VALIDATION_MEMBER');
}

export function useFeatureAddressValidationClientPortal(): boolean {
  return useFeatureEnabled('ADDRESS_VALIDATION_CLIENT');
}

export function useFeatureAddressValidationF1(): boolean {
  return useFeatureEnabled('ADDRESS_VALIDATION_F1');
}
